<template>
  <div id="printDelivery">
    <div class="section">
      <div class="columns is-variable is-multiline">
        <div class="column is-3 ">
          <figure class="image is-128x128 center-content">
            <img
              class=""
              src="../../assets/imgs/logo-petit-nature.jpg"
              alt=""
            />
          </figure>
        </div>
        <div class="column is-6 center-content">
          <h1 class="title has-text-centered">Entrega</h1>
        </div>
        <div class="column is-3 center-content">
          <div class="label">
            {{ delivery.date | moment("DD/MM/YYYY") }}
          </div>
        </div>
      </div>
      <div
        v-for="customer in delivery.deliveryCustomers"
        :key="customer.id"
        class="column is-12 customer-holder"
      >
        <div
          v-if="customer.customerName"
          class="columns is-variable is-multiline has-text-left"
        >
          <div class="column is-6">
            <div class="label">Cliente</div>
            <div>{{ customer.customerName }}</div>
          </div>
          <div class="column is-6">
            <div class="label">Endereço</div>
            <div>{{ getAddress(customer.address) }}</div>
            <div v-if="customer.address.complement">
              {{ customer.address.complement }}
            </div>
          </div>
          <!--Table -->
          <div class="column is-12">
            <div>Pets</div>
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Consumo</th>
                  <th>Receitas</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pet in customer.pets" :key="pet.id">
                  <td>{{ pet.pet.name }}</td>
                  <td>{{ pet.pet.consumption }}g</td>
                  <td>
                    <div
                      v-for="product in pet.deliveryProducts"
                      :key="product.receipt + product.quantity"
                    >
                      {{ product.quantity }} {{ product.receipt }}
                      {{ product.packageSize }}g
                      <strong>({{ product.batch }})</strong></div
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="column is-12 has-text-centered" style="margin-top: 25px">
            <div class="sign-line">
              ____________________________________________
            </div>
            <h2 class="subtitle">
              Recebedor
            </h2>
          </div>
        </div>
      </div>
      <div class="column is-12 sign-holder has-text-centered">
        <div class="sign-line">
          ____________________________________________
        </div>
        <h2 class="subtitle">
          Responsável pela entrega
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../helpers/EventBus";
import Vue from "vue";

export default {
  name: "PrintDelivery",
  data: () => ({
    delivery: {}
  }),
  methods: {
    getAddress(address) {
      return (
        address.street +
        ", " +
        address.number +
        ", " +
        address.neighborhood +
        ", " +
        address.cep
      );
    }
  },
  created() {
    EventBus.$on("print:delivery", delivery => {
      let that = this;
      this.delivery = delivery;
      //Used here to ensure that functions will be called only when object has values
      Vue.nextTick(function() {
        that.$htmlToPaper("printDelivery");
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("print:delivery");
  }
};
</script>

<style lang="scss" scoped>
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
